import { EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { EventSystemComplete } from "../../models/event-systems/event-system-complete.model";
import { EventSystemDetailed } from "../../models/event-systems/event-system-detailed.model";

export const systemAdapter: EntityAdapter<EventSystemDetailed> = createEntityAdapter<EventSystemDetailed>({
    selectId: (system) => system.systemID
});